import { render, staticRenderFns } from "./TagsBar.vue?vue&type=template&id=6ed6a5cc&scoped=true"
import script from "./TagsBar.vue?vue&type=script&lang=js"
export * from "./TagsBar.vue?vue&type=script&lang=js"
import style0 from "./TagsBar.vue?vue&type=style&index=0&id=6ed6a5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6a5cc",
  null
  
)

export default component.exports